import { render, staticRenderFns } from "./Percent.vue?vue&type=template&id=3b850680&"
import script from "./Percent.vue?vue&type=script&lang=js&"
export * from "./Percent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports